import { render, staticRenderFns } from "./productperformance.vue?vue&type=template&id=9f3e0526&scoped=true&"
import script from "./productperformance.vue?vue&type=script&lang=js&"
export * from "./productperformance.vue?vue&type=script&lang=js&"
import style0 from "./productperformance.vue?vue&type=style&index=0&id=9f3e0526&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f3e0526",
  null
  
)

export default component.exports